import { render, staticRenderFns } from "./potentialGoodsOrder.vue?vue&type=template&id=66c29582&scoped=true&"
import script from "./potentialGoodsOrder.vue?vue&type=script&lang=js&"
export * from "./potentialGoodsOrder.vue?vue&type=script&lang=js&"
import style0 from "./potentialGoodsOrder.vue?vue&type=style&index=0&id=66c29582&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c29582",
  null
  
)

component.options.__file = "potentialGoodsOrder.vue"
export default component.exports